import { Button } from "@greeter/matter";

export function FailedSection(props: { onClick?: () => void; reason: string }) {
  return (
    <div
      style={{
        height: 100,
        width: "100%",
        display: "grid",
        placeItems: "center",
        borderRadius: 10,
      }}
    >
      <p style={{ color: "var(--gm-color-dark-primary)" }}>{props.reason}</p>
      <Button onClick={props.onClick}>Prøv igen</Button>
    </div>
  );
}
